/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type Patient from "parog-web/models/patient";
import type JesHistoryTableComponent from "..";
import type JesHistoryTableColumnComponent from "../column";

interface Signature {
  Args: {
    patient: Patient;
    table: JesHistoryTableComponent;
  };
}

export default class JesHistoryTableAddButtonComponent extends Component<Signature> {
  get actionnableColumns(): JesHistoryTableColumnComponent[] {
    // If a column does not have a @feature and a @component provided then it is not counting as a possible action
    return this.args.table.columns.filter(column =>
      Boolean(column.fullComponentId)
    );
  }
}
